export const ProfileSettingsIcon: React.FC<{ color?: string }> = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path
			fill={color || "#367BF5"}
			d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
		/>
	</svg>
);

export const OrganizationSettingsIcon: React.FC<{ color?: string }> = ({ color }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#oha30pgjka)">
			<path
				d="M19.502 12.971c.04-.317.07-.634.07-.971 0-.337-.03-.654-.07-.972l2.13-1.635a.494.494 0 0 0 .12-.635l-2.018-3.43a.506.506 0 0 0-.444-.247.48.48 0 0 0-.172.03l-2.513.99a7.406 7.406 0 0 0-1.706-.97l-.384-2.628a.49.49 0 0 0-.494-.416H9.983a.49.49 0 0 0-.494.416L9.105 5.13a7.79 7.79 0 0 0-1.706.972L4.886 5.11a.581.581 0 0 0-.182-.03.502.502 0 0 0-.434.248l-2.018 3.43a.483.483 0 0 0 .12.635l2.13 1.635c-.04.318-.07.645-.07.972 0 .327.03.654.07.971l-2.13 1.636a.494.494 0 0 0-.12.635l2.018 3.43c.091.158.263.247.444.247.061 0 .122-.01.172-.03l2.513-.99c.525.396 1.09.723 1.706.97l.384 2.628a.49.49 0 0 0 .494.416h4.038a.49.49 0 0 0 .494-.416l.384-2.627a7.788 7.788 0 0 0 1.706-.972l2.513.992c.06.02.121.03.182.03.171 0 .343-.09.434-.249l2.018-3.43a.494.494 0 0 0-.12-.634l-2.13-1.636zm-1.999-1.695c.04.308.05.516.05.724 0 .208-.02.426-.05.724l-.141 1.12.898.694 1.09.832-.706 1.2-1.282-.506-1.05-.416-.908.674a5.934 5.934 0 0 1-1.262.724l-1.07.426-.161 1.12-.202 1.338h-1.413l-.192-1.338-.162-1.12-1.07-.426a5.752 5.752 0 0 1-1.241-.704l-.919-.694-1.07.426-1.282.506-.706-1.2 1.09-.832.898-.694-.141-1.12a7.834 7.834 0 0 1-.05-.734c0-.198.02-.426.05-.724l.141-1.12-.898-.694-1.09-.832.706-1.2 1.282.506 1.05.416.909-.674a5.938 5.938 0 0 1 1.261-.724l1.07-.426.162-1.12.202-1.338h1.402l.192 1.338.162 1.12 1.07.426c.434.179.838.407 1.241.704l.919.694 1.07-.426 1.282-.506.706 1.2-1.08.842-.898.694.141 1.12zm-5.5-3.241C9.77 8.035 7.964 9.809 7.964 12c0 2.19 1.806 3.965 4.037 3.965 2.23 0 4.037-1.774 4.037-3.965 0-2.19-1.806-3.965-4.037-3.965zm0 5.948c-1.111 0-2.02-.893-2.02-1.983s.909-1.983 2.02-1.983c1.11 0 2.018.893 2.018 1.983s-.909 1.983-2.019 1.983z"
				fill={color || "#367BF5"}
			/>
		</g>
		<defs>
			<clipPath id="oha30pgjka">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const TermsPoliciesIcon: React.FC<{ color?: string }> = ({ color }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.156 15.072h-7v-2h7v2zm3-4h-10v-2h10v2zm0-4h-10v-2h10v2zm-16-2v16h16v2h-16a2 2 0 0 1-2-2v-16h2zm18-4a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2h-14a2 2 0 0 1-2-2v-14c0-1.11.89-2 2-2h14zm-14 2v14h14v-14h-14z"
			fill={color || "#367BF5"}
		/>
	</svg>
);

export const UptimeItemIcon: React.FC<{ color?: string }> = ({ color }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18.5 20.333a1 1 0 0 0 1-1V9.667a1 1 0 0 0-1-1h-1.333a1 1 0 0 0-1 1v9.666a1 1 0 0 0 1 1H18.5zm-5.833 0a1 1 0 0 0 1-1V4.667a1 1 0 0 0-1-1h-1.334a1 1 0 0 0-1 1v14.666a1 1 0 0 0 1 1h1.334zm-5.834 0a1 1 0 0 0 1-1v-4.666a1 1 0 0 0-1-1H5.5a1 1 0 0 0-1 1v4.666a1 1 0 0 0 1 1h1.333z"
			fill="#367BF5"
		/>
	</svg>
);
